<template>
    <li v-for="item in arborescence" :key="item.path" :style="{ marginLeft: level + 30 + 'px' }">
        <div v-if="item.type === 'dossier'" class="headArbo">
            <input v-if="loggedInRole=='admin' || loggedInRole=='gestion'" type="checkbox" id="selec" name="selec" @change="toggleDeletePath(item.path)" /> 
            <div @click="toggleOpen(item)" class="folder-header">
              <svg v-if="item.type === 'dossier'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-fill" viewBox="0 0 16 16">
                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                </svg>
                {{ item.name }}
            </div>
            <!-- Zone de dépôt pour le dossier -->
            
        </div>
        
        <div v-else class="headArbo">
            <input v-if="loggedInRole=='admin' || loggedInRole=='gestion'" type="checkbox" id="selec" name="selec"  @change="toggleDeletePath(item.path)"/>
            <a @click.stop="openFilePopup(item)" class="linkArbo">{{ item.name }}</a>
        </div>
        <ul v-if="item.type === 'dossier' && item.isOpen">
            <TreeItem 
              :getFichiers="getFichiers" 
              :toggleDeletePath="toggleDeletePath" 
              :arborescence="item.children" 
              :deletePaths="this.deletePaths" 
              :level="level + 1"
              :handleDrop="handleDrop"
              :handleDragOver="handleDragOver"
              :handleDragEnter="handleDragEnter"
              :handleDragLeave="handleDragLeave"
              :dragOverFolder="dragOverFolder"
              :uploadFiles="uploadFiles"
            ></TreeItem>
            <div 
              v-if="loggedInRole=='admin' || loggedInRole=='gestion'"
              class="drop-zone folder-drop-zone"
              :class="{ 'drag-over': dragOverFolder === item.path }"
              @drop="handleDrop($event, item.path)"
              @dragover="handleDragOver"
              @dragenter="handleDragEnter($event, item.path)"
              @dragleave="handleDragLeave($event, item.path)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-upload" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-3.746 1.996 3.686 3.686 0 0 0 .180 6.741A1.5 1.5 0 0 1 6 11.5a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-.956-1.996 2.686 2.686 0 0 1-.004-5.162z"/>
                <path fill-rule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
              </svg> Déposer vos ou votre fichier ici
            </div>
            <a v-if="loggedInRole=='admin' || loggedInRole=='gestion'" @click="addElement(item.path)" class="linkArbo addElement" href="#" :style="{ marginLeft: level + 30 + 'px' }">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-plus" viewBox="0 0 16 16">
                <path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9.81a2 2 0 0 0 1.991-1.819l.637-7c.124-.684-.295-1.335-.956-1.56L10.5 3a.5.5 0 0 0-.5-.5h-3.672a.5.5 0 0 0-.354.146L5.828 2.5H2.5a.5.5 0 0 0-.5.5z"/>
                <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"/>
              </svg>
              Ajouter un dossier
            </a>
        </ul>
    </li>

  <div v-if="showFileUploadForm" class="file-upload-form" @click="closePopup">
      <div class="file-upload-form-content download" @click.stop>
        <a class="close-button" @click="closePopup">&times;</a>
        <h2>Ajouter un dossier</h2>         
        
        <form @submit.prevent="submit">
          <input id="texte" type="text" v-model="dossier" placeholder="Nom du dossier" required>
          <button type="submit">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-plus" viewBox="0 0 16 16">
              <path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9.81a2 2 0 0 0 1.991-1.819l.637-7c.124-.684-.295-1.335-.956-1.56L10.5 3a.5.5 0 0 0-.5-.5h-3.672a.5.5 0 0 0-.354.146L5.828 2.5H2.5a.5.5 0 0 0-.5.5z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"/>
            </svg>
            Créer le dossier
          </button>
        </form>

        <div v-if="successFichierArticle" class="alert alert-success" role="alert">
          {{ successFichierArticle }}
        </div>
        <div v-if="errorFichierArticle" class="alert alert-danger" role="alert">
            {{ errorFichierArticle }}
        </div>
      </div>
  </div>

  <div v-if="showFileViewer" class="file-upload-form" @click="closePopup">
    <div class="file-upload-form-content" @click.stop>
      <a class="close-button" @click="closePopup">&times;</a>
      <!-- Afficher le fichier ici, par exemple, dans une iframe pour les fichiers PDF -->
      <iframe v-if="extFile == 'pdf'" :src="linkFile" width="100%" height="500"></iframe>
      <img v-if="extFile == 'jpeg' || extFile == 'jpg' || extFile == 'png' || extFile == 'webp'" :src="linkFile" alt="Image"/>
      <div v-if="extFile == 'igs' || extFile == 'prt' || extFile == 'vcf' || extFile == 'step' || extFile == 'stp' || extFile == 'STEP'">
        <iframe :src="`//sharecad.org/cadframe/load?url=${linkFile}`" scrolling="no"></iframe>
        <div class="download-btn-wrapper">
          <a @click.prevent="downloadCurrentFile" class="btn-download-file" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
            Télécharger le fichier
          </a>
        </div>
      </div>
    </div>
  </div>
    
</template>
  
<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'
import { downloadFile } from '@/mixins/imageCompressionMixin.js'

export default {
  name: 'TreeItem',
  props: {
    getFichiers: Function,
    toggleDeletePath: Function,
    deletePaths: Array,
    arborescence: Array,
    level: {
      type: Number,
      default: 0,
    },
    handleDrop: Function,
    handleDragOver: Function,
    handleDragEnter: Function,
    handleDragLeave: Function,
    dragOverFolder: String,
    uploadFiles: Function,
  },
  data() {
    return {
      naf: '',
      showFileUploadForm: false,
      showFileViewer: false,
      path: '',
      linkFile: '',
      extFile: '',
      fichiers: [],
      successFichierArticle: '',
      errorFichierArticle: '',
      dossier: "",
      loggedInRole: ""
    }
  },
  created() {
    this.naf = this.$route.params.naf;
    const role = VueCookies.get('role')
    if (role) {
      this.loggedInRole = role
    }
  },
  methods: {
    toggleOpen(item) {
      console.log("toggled");
      item.isOpen = !item.isOpen;
    },
    addElement(item) {
      this.path = item;
      this.dossier = ""; // Reset le champ
      this.showFileUploadForm = true;
    },
    openFilePopup(item) {
      const supportedExtensions = ['pdf', 'jpeg', 'jpg', 'png', 'webp', 'igs', 'prt', 'vcf', 'step', 'stp'];
      const ext = item.extension ? item.extension.toLowerCase() : '';
      const fileUrl = item.path.replace("/simef", "https://www.simef.fr");
      if (!supportedExtensions.includes(ext)) {
        downloadFile(fileUrl, item.name || item.path.split('/').pop());
        return;
      }
      this.showFileViewer = true;
      this.linkFile = fileUrl;
      this.extFile = ext;
    },
    downloadCurrentFile() {
      downloadFile(this.linkFile, this.linkFile.split('/').pop());
    },
    closePopup(event) {
      event.stopPropagation();
      this.showFileUploadForm = false;
      this.showFileViewer = false;
    },
    submit() {
      // Création de dossier uniquement
      const formData = new FormData();

      // Pas de fichiers, seulement le dossier
      formData.append('path', this.path);
      formData.append('dossier', this.dossier);
      formData.append('naf', this.naf);

      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutFichiersArbo.php', formData)
      .then(response => {
        this.successFichierArticle = response.data.successFichierArticle;
        this.errorFichierArticle = response.data.errorFichierArticle;
        this.dossier = ""; // Reset le nom du dossier
        this.getFichiers();
        
        // Fermer la popup après succès
        if (response.data.successFichierArticle) {
          setTimeout(() => {
            this.showFileUploadForm = false;
            this.successFichierArticle = '';
          }, 1500);
        }
      })
      .catch(error => {
        console.error(error);
        this.errorFichierArticle = "Une erreur est survenue lors de la création du dossier";
      });
    },
    
    addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
          this.fichiers.push(files[i]);
      }
    },
  },
};
</script>

<style lang="scss">
$primary: #2b358d;

.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 4px;
  padding: 10px;
  margin: 5px 0;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &.drag-over {
    border-color: $primary;
    background-color: rgba($primary, 0.1);
    
    svg {
      color: $primary;
    }
  }
  
  svg {
    margin-right: 5px;
    color: #666;
  }
  
  span {
    font-size: 0.9rem;
    color: #666;
  }
}

.folder-drop-zone {
  display: inline-block;
  padding: 5px 8px;
  margin-left: 10px;
  border: 1px dashed #ddd;
  border-radius: 3px;
  font-size: 0.8rem;
  
  svg {
    margin-right: 3px;
  }
}

.headArbo {
  display: flex;
  align-items: center;
  gap: 10px;
  
  .folder-header {
    display: flex;
    align-items: center;
    cursor: pointer;
    
    svg {
      margin-right: 5px;
    }
  }
}

.addElement {
  font-weight: 900;
  font-size: 0.9rem!important;
  display: flex;
  align-items: center;
  gap: 5px;
  
  svg {
    margin-right: 3px;
  }
}

.file-upload-form {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    .file-upload-form-content {
      @media screen and (max-width:992px) {
        min-width: unset;
        width: 100%;
      }
      max-width: 850px;
      min-width: 850px;
      position: relative;
      max-height: 90%;
      background-color: #fff;
      border-radius: 0px;
      text-align: center;
      iframe {
        width: 100%;
        min-height: 400px;
      }
      h2 {
        text-align: center!important;
      }
    }
  }
  .close-button {
    font-size: 30px!important;
    background: unset!important;
    color: #2b358d!important;
  }
</style>